/**
 * Use this file for JavaScript code that you want to run in the front-end 
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any 
 * JavaScript running in the front-end, then you should delete this file and remove 
 * the `viewScript` property from `block.json`. 
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */
 
/* eslint-disable no-console */
console.log("Hello World! (from create-block-bmi-calculator block)");
/* eslint-enable no-console */

// --- Calculation Functions ---
function calculateBMI(weight, height, unit) {
    if (unit === 'metric') return weight / (height * height);
    if (unit === 'imperial') return (weight / (height * height)) * 703;
    throw new Error("Unit must be 'metric' or 'imperial'.");
}

// --- Main Logic ---
document.addEventListener("DOMContentLoaded", () => {

	const form = document.getElementById("bmiForm");

	const heightFeetInput = document.getElementById("heightFeet");
	const heightInchesInput = document.getElementById("heightInches");
	const currentWeightInput = document.getElementById("currentWeight");

	let bmi = null;

	const updateBMICard = () => {
     	const hF = parseFloat(heightFeetInput.value), hI = parseFloat(heightInchesInput.value), cW = parseFloat(currentWeightInput.value);
		const bmiDisplay = document.getElementById("displayBMI");
		const bmiStatus = document.getElementById("bmiStatus");

		if (isNaN(hF) || isNaN(hI) || isNaN(cW) || cW <= 0) {
			bmi = null;
			if(bmiDisplay) bmiDisplay.textContent = "--";
			if(bmiStatus) bmiStatus.textContent = "Your BMI";
			return;
		}

		bmi = calculateBMI(cW, (hF * 12) + hI, "imperial");
		if(bmiDisplay) bmiDisplay.textContent = bmi.toFixed(1);

		// --- BMI STATUS UPDATE LOGIC ---
		if (bmiStatus) {
			let activePill = 0;
			if (bmi < 18.5) {
				bmiStatus.className = "card-label bmi-underweight";
				// bmiBarsPaths[0].setAttribute('class', 'active');
			} else if (bmi >= 18.5 && bmi <= 24.9) {
				bmiStatus.className = "card-label bmi-normal";
				// bmiBarsPaths[1].setAttribute('class', 'active');
				activePill = 1;
			} else if (bmi > 24.9 && bmi <= 29.9) {
				bmiStatus.className = "card-label bmi-overweight";
				// bmiBarsPaths[2].setAttribute('class', 'active');
				activePill = 2;
			} else {
				bmiStatus.className = "card-label bmi-obese";
				// bmiBarsPaths[3].setAttribute('class', 'active');
				activePill = 3;
			}

			for (let i = 0; i < 4; i++) {
				
				let bmiBarsDefs = document.querySelector( '.bar-' + (i+1) + ' svg defs' );
				let lG = bmiBarsDefs.children[0];
				let bmiBarsLevels = document.querySelectorAll( '.level' );
				let bmiBars = document.querySelectorAll( '.bar' );
				
				if( i == activePill ){
					lG.children[0].setAttribute('stop-color', '#EDF7F3');
					lG.children[1].setAttribute('stop-color', '#99C9CB');
					lG.children[2].setAttribute('stop-color', '#339496');
					bmiBarsLevels[i].children[0].classList.add('active');
					bmiBars[i].classList.add('active');
				} else {
					lG.children[0].setAttribute('stop-color', '#FDE0D6');
					lG.children[1].setAttribute('stop-color', '#F7AA8F');
					lG.children[2].setAttribute('stop-color', '#F39270');
					bmiBarsLevels[i].children[0].classList.remove('active');
					bmiBars[i].classList.remove('active');
				}
			}
		}
	};

	form.addEventListener("submit", (event) => {
		event.preventDefault();

     	const hF = parseFloat(heightFeetInput.value), hI = parseFloat(heightInchesInput.value), cW = parseFloat(currentWeightInput.value);

		if ( isNaN(hF) || isNaN(hI) || !cW ) {
			showToast("Please fill in all fields to unlock your personalized plan.");
			return;
		}

		try {
			updateBMICard(); // Ensure BMI and Status are refreshed on submit

		} catch (e) {
			console.error(e);
			showToast("Error processing plan. Please check inputs.");
		}
	});
});